<template>
<div>
    <Slide :pageOption="pageOption" />

    <div class="mainSite">
        <div v-if="category_slug=='preview'" class="text-center">
            <div class="preview">PREVIEW</div>
        </div>

        <div class="row mt-2 align-items-center mb-1"  v-if="category">
            <div class="col-sm-4">
                <router-link :to="category.to">
                    <div class="categoryTitle ms"><img :src="category.icon" v-if="category.icon" /> <span v-else>{{category.title}}</span></div>
                </router-link>
            </div>
        

        </div>

        <div v-if="item" class="mt-5 animate__animated animate__fadeIn">
            <div v-if="memberOnly(item)">
                <NotAllow :item="item" />
                <div v-if="item.mode != 'notAllow'">

                    <v-card max-width="1200" class="mx-auto">
                        <v-card-text class="itemHeader">
                            <h1>{{item.title}}</h1>
                        </v-card-text>
                        <v-divider></v-divider>

                        <TestDetail :item="pretest.userTest" type="pretest" @update="getItem()" v-if="pretest" />
                        <TestDetail :item="posttest.userTest" type="posttest" @update="getItem()" v-if="posttest" />

                        <v-card-text v-if="!pretest.exam" class="animate__animated animate__fadeIn">
                            <div v-if="item.picture" class="itemPicture">
                                <img :src="item.picture.picture_big" />
                            </div>

                            <Html :item="item" :pageOption="pageOption" />

                        </v-card-text>

                        <v-card-text v-if="pretest.exam" class="animate__animated animate__fadeIn">
                            <div class="pa-5 pb-0 html">

                                <Exam :item="pretest.exam" @complete="getItem()" />

                            </div>
                        </v-card-text>

                        <v-card-text v-if="posttest.exam && !pretest.exam" class="animate__animated animate__fadeIn">
                            <div class="pa-5 pb-0 html">
                                <Exam :item="posttest.exam" @complete="getItem()" />
                            </div>
                        </v-card-text>

                    </v-card>
                </div>
            </div>
        </div>

    </div>
</div>
</div>
</template>

<script>
import TestDetail from '@/inc/Exam/TestDetail'
import Exam from '@/inc/Exam/Exam'
export default {

    components: {
        TestDetail,
        Exam
    },
    props: {

    },

    data: () => ({
        category: null,

        totalView: null,
        item: null,
        display: null,
        pretest: {
            exam: null,
            userTest: null
        },
        posttest: {
            exam: null,
            userTest: null
        },
        pageOption: null

    }),

    computed: {
        category_slug() {
            return this.$route.params.category_slug;
        },
    },

    watch: {

    },
    methods: {

        getItem() {

            let url = "content/one";

            let data = {}
            data.item_id = this.item_id
            data.category_slug = this.category_slug

            const formData = this.$formData(
                data
            );

            this.$FULL_LOADING = true
            let $vm = this;

            this.$API
                .post(url, $vm.formData(formData))
                .then(function (res) {

                    $vm.checkApi(res);
                    $vm.item = res.data.item

                    $vm.display = res.data.display
                    $vm.pretest = res.data.pretest
                    $vm.posttest = res.data.posttest
                    $vm.pageOption = res.data.pageOption
                    $vm.totalView = res.data.totalView

                    $vm.$CURRENT_CONTENT_ID = res.data.item.content_id

                    if ($vm.item.mode == 'publish') {
                        $vm.category = res.data.category
                        if (!res.data.pretest.exam) {
                            $vm.setPointTime(res.data.point)
                        }
                    }

                })
                .catch(function (error) {
                    console.log(error);
                });

        }

    },
    created() {

        this.getItem();

    },
};
</script>
